import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import type { EnrichedTokenEvent } from '@revoke.cash/core/events';
import AssetDisplay from 'components/allowances/dashboard/cells/AssetDisplay';
import Button from 'components/common/Button';
import WithHoverTooltip from 'components/common/WithHoverTooltip';
import { useTranslations } from 'next-intl';

interface Props {
  event: EnrichedTokenEvent;
  onFilter?: (filterValue: string) => void;
}

const HistoryAssetCell = ({ event, onFilter }: Props) => {
  const t = useTranslations();

  const asset = {
    metadata: event.metadata,
    chainId: event.chainId,
    token: {
      address: event.token,
    },
  };

  const handleFilterClick = () => {
    if (onFilter) {
      const filterValue = event.token;
      onFilter(`token:${filterValue}`);
    }
  };

  const filterButton = (
    <WithHoverTooltip tooltip={t('address.tooltips.filter_by_token')}>
      <Button
        style="none"
        size="none"
        onClick={handleFilterClick}
        aria-label={`Filter by token ${asset.metadata.symbol}`}
      >
        <MagnifyingGlassIcon className="w-4 h-4 text-zinc-500 dark:text-zinc-400 hover:text-zinc-700 dark:hover:text-zinc-200" />
      </Button>
    </WithHoverTooltip>
  );

  return (
    <div className="flex items-center gap-2 py-1 w-fit">
      <div className="flex flex-col items-center py-2">
        <AssetDisplay asset={asset} />
      </div>
      {onFilter ? filterButton : null}
    </div>
  );
};

export default HistoryAssetCell;
